/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "api1",
            "endpoint": "https://em1yggs0yl.execute-api.eu-west-2.amazonaws.com/release",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:4f6b3d92-d813-4d15-b309-a6940b0ca49c",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_QbVYzifVV",
    "aws_user_pools_web_client_id": "3as4i8h6d3j18i4kce0fu0a32v",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "events-release",
            "region": "eu-west-2"
        },
        {
            "tableName": "nutritionUsers-release",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
